var _defs, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 526.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #009fe3;\n      }\n\n      .cls-2 {\n        font-family: OpenSans-Bold, 'Open Sans';\n        font-size: 400px;\n        font-weight: 700;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m250,15c31.73,0,62.51,6.21,91.47,18.46,27.98,11.84,53.12,28.78,74.7,50.37,21.59,21.59,38.53,46.72,50.37,74.7,12.25,28.96,18.46,59.74,18.46,91.47s-6.21,62.51-18.46,91.47c-11.84,27.98-28.78,53.12-50.37,74.7s-46.72,38.53-74.7,50.37c-28.96,12.25-59.74,18.46-91.47,18.46s-62.51-6.21-91.47-18.46c-27.98-11.84-53.12-28.78-74.7-50.37-21.59-21.59-38.53-46.72-50.37-74.7-12.25-28.96-18.46-59.74-18.46-91.47s6.21-62.51,18.46-91.47c11.84-27.98,28.78-53.12,50.37-74.7,21.59-21.59,46.72-38.53,74.7-50.37,28.96-12.25,59.74-18.46,91.47-18.46m0-15C111.93,0,0,111.93,0,250s111.93,250,250,250,250-111.93,250-250S388.07,0,250,0h0Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(188.96 409.43)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "i"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.00880ef4eef5cf4784b430ee009f1d94.svg";
export { ForwardRef as ReactComponent };